/** Match stored niche tags without requiring customers to distinguish casing. */
export const nicheKey = (value: string) => value.trim().toLowerCase();

export function availableNiches(templates: ReadonlyArray<{ niche?: string[] | null }>): string[] {
  const names = new Map<string, string>();
  for (const template of templates) {
    for (const name of template.niche ?? []) {
      const key = nicheKey(name);
      if (key && !names.has(key)) names.set(key, name.trim());
    }
  }
  return Array.from(names.values()).sort((a, b) => a.localeCompare(b));
}

export function nicheLabel(value: string): string {
  const labels: Record<string, string> = { saas: 'SaaS', b2b: 'B2B', cbd: 'CBD', ugc: 'UGC' };
  return labels[nicheKey(value)] ?? value.replace(/[-_]+/g, ' ').replace(/\b\w/g, character => character.toUpperCase());
}

export function matchesNiche(niches: string[] | null | undefined, selected: string[]): boolean {
  return !selected.length || (niches ?? []).some(value => selected.some(filter => nicheKey(value) === nicheKey(filter)));
}
